import React from 'react';
import './index.css';
import Logo from '../../Assets/logo.svg';

// Packages
import { Link } from 'react-router-dom';

function FooterComponent() {
    return (
        <>
            <header>
                <Link to="/"><img src={Logo} alt='AlgorithmX' /></Link>
            </header>
        </>
    );
}

export default FooterComponent;
